import { Button, Checkbox, Input, Select, Tooltip, Typography } from "antd";
import crossIcon from "../../assets/Icons/crossIcon.svg";
import searchIcon from "../../assets/Icons/input-search-icon.svg";
import Tabs from "../Tabs/Tabs";
import "./ActionHeader.scss";

import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { fetchAnalyseFilters, setQuery } from "../../store/filters";
import { fetchPortfolios } from "../../store/portfolioSlice";
import { appendTrusts } from "../../store/trusts";
import RangePickerWithPresets from "../RengePicker/RangePickerWithPresets";
import AppliedFilterChips from "./AppliedFilterChips";
import FilterDropdown from "./Filter";

const { Text } = Typography;
const ActionHeader = ({
  heading,
  primaryItems = [],
  setSecondaryItems,
  setPrimaryItems,
  secondaryItems = [],
  setSelectedTrusts,
  selectedTrusts = [],
  filterKyes = ["region", "state", "status"],
  fetchData,
  fetchData2,
  fetchData3,
  setRefresh = () => {},
}) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const selectRef = useRef(null);
  const dropdownRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [selectedTab, setSelectedTab] = useState("All");
  const { token } = useSelector((state) => state.auth);
  const [latestItems, setLatestItems] = useState([]);
  const { trust_list, selected_trusts } = useSelector((state) => state.trust);
  const { query, analyse_filters } = useSelector((state) => state.filters);
  const [list, setList] = useState([]);
  const dispatch = useDispatch();
  const [ids, setIds] = useState(query?.trust_id || []);
  const { pathname } = useLocation();
  const [isProductivity, setIsProductivity] = useState(false);
  const { portfolios } = useSelector((state) => state.portfolio);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsSmallScreen(window.innerWidth <= 620);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  useEffect(() => {
    dispatch(
      setQuery({
        trust_id: ids,
      }),
    );
  }, [ids]);

  useEffect(() => {
    if (
      pathname === "/analysis/productivity" ||
      pathname === "/analysis/performance"
    ) {
      setIsProductivity(true);
      dispatch(
        setQuery({
          trust_id: [portfolios?.[0]?.id],
        }),
      );
    }
  }, [pathname, list]);

  useEffect(() => {
    if (
      pathname === "/analysis/productivity" ||
      pathname === "/analysis/performance" ||
      pathname === "/analysis/overview" ||
      pathname === "/analysis/coverage"
    ) {
      dispatch(fetchAnalyseFilters());
    }
  }, [pathname]);

  const handleClose = () => {
    setDropdownOpen(false);
  };

  useEffect(() => {
    setList(portfolios);
  }, [portfolios]);

  const handleSearchTrusts = (e) => {
    const value = e.target.value.toLowerCase();
    const filteredList = portfolios?.filter((trust) =>
      trust?.name?.toLowerCase().includes(value),
    );
    setList(filteredList);
  };

  const handleApplyPortfolio = async () => {
    handleClose();
    setRefresh((prev) => !prev);
    if (latestItems?.length > 0) {
      fetchData && dispatch(fetchData());
      if (typeof fetchData2 === "function") {
        dispatch(fetchData2());
      }
      if (typeof fetchData3 === "function") {
        dispatch(fetchData3());
      }
    }
  };

  const handleRemoveTag = (key, item) => {
    if (key === "trust_id") {
      const newIds = ids.filter((i) => i !== item);
      setIds(newIds);
      dispatch(appendTrusts({ type: "individual", data: item }));

      dispatch(setQuery({ ...query, trust_id: newIds }));

      fetchData && dispatch(fetchData());
      if (fetchData2) dispatch(fetchData2());
      if (fetchData3) dispatch(fetchData3());
    } else {
      const newList = query[key].filter((i) => i !== item);
      dispatch(setQuery({ ...query, [key]: newList }));

      // Delay fetch slightly to ensure query update allows backend call if needed,
      // though typically dispatch is synchronous for state update.
      // Re-triggering fetch:
      fetchData && dispatch(fetchData());
      if (fetchData2) dispatch(fetchData2());
      if (fetchData3) dispatch(fetchData3());
    }
  };

  const selectedPortfolioCount = Array.isArray(query?.trust_id)
    ? query.trust_id.length
    : 0;

  const dropdownRender = () => (
    <div className="secondary-select-dropdown" ref={dropdownRef}>
      <div className="heading">
        <h2>Portfolio</h2>
        {selectedPortfolioCount > 0 && (
          <span className="count-badge">{selectedPortfolioCount}</span>
        )}
        <img
          src={crossIcon}
          alt=""
          onClick={handleClose}
          style={{ cursor: "pointer" }}
        />
      </div>
      <div className="metric-search-input">
        <Input
          prefix={<img src={searchIcon} alt="icon" />}
          placeholder="Search"
          allowClear
          onChange={handleSearchTrusts}
        />
      </div>
      <div className="metric-title">
        <h2>Metrics</h2>
      </div>
      <div className="select-all-container">
        {!isProductivity && (
          <Button size="small" type="text" onClick={handleSelectAll} danger>
            Select All
          </Button>
        )}
      </div>

      <div className="checkbox-list">
        {list?.length > 0 ? (
          list?.map((item) => {
            const trust_name =
              item?.name?.length > 32 ? (
                <Tooltip title={item?.name}>
                  {item?.name?.slice(0, 30) + "..."}
                </Tooltip>
              ) : (
                item?.name
              );
            return (
              <Checkbox
                key={item}
                checked={
                  Array.isArray(query?.trust_id) &&
                  query.trust_id.includes(item?.id)
                }
                onChange={() =>
                  isProductivity
                    ? handleCheckBox(item?.id)
                    : handleCheckboxChange(item?.id)
                }
              >
                {trust_name}
              </Checkbox>
            );
          })
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "100%",
            }}
          >
            <p style={{ marginLeft: "-30px" }}>No items</p>
          </div>
        )}
      </div>
      <div className="portfolio-dropdown-footer">
        <span className="footer-count">
          {selectedPortfolioCount > 0
            ? `${selectedPortfolioCount} selected`
            : "Nothing selected"}
        </span>
        <Button className="apply-portfolio-btn" onClick={handleApplyPortfolio}>
          Apply
        </Button>
      </div>
    </div>
  );
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        selectRef.current &&
        dropdownRef.current &&
        !selectRef.current.contains(event.target) &&
        !dropdownRef.current.contains(event.target)
      ) {
        handleClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleCheckboxChange = (value) => {
    dispatch(appendTrusts({ type: "individual", data: value }));
    setIds((prev) => {
      if (prev?.includes(value)) {
        return prev?.filter((id) => id !== value); // remove if exists
      } else {
        return [...prev, value]; // add if not exists
      }
    });
    setLatestItems([value]);
  };

  const handleCheckBox = (value) => {
    setIds([value]);
    setLatestItems([value]);
  };

  const handleSelectAll = () => {
    const allTrustIds = list?.map((item) => item?.id);
    dispatch(appendTrusts({ type: "all", data: allTrustIds }));
    setLatestItems(allTrustIds);
    setIds(allTrustIds);
  };
  const handleRemovePrimaryItem = (itemToRemove) => {
    setPrimaryItems((prevItems) =>
      prevItems.filter((item) => item !== itemToRemove),
    );
  };

  useEffect(() => {
    dispatch(fetchPortfolios());
  }, [token]);

  return (
    <>
      <div className="action-header-container">
        <div className="left">
          <Text className="heading">{heading}</Text>
        </div>
        <div className="right">
          {isSmallScreen ? (
            <Select
              // value={selectedItems}
              // open={dropdownOpen}
              defaultValue={"All"}
              options={[
                {
                  label: "All",
                  value: "All",
                },
                {
                  label: "Active",
                  value: "Active",
                },
                {
                  label: "Inactive",
                  value: "Inactive",
                },
              ]}
              onChange={(val) => setSelectedTab(val)}
              // onMouseEnter={() => setDropdownOpen((prev) => !prev)}
              // dropdownRender={dropdownRender}
              // style={{ width: 300 }}
              // placeholder=""
            />
          ) : (
            <Tabs
              options={[
                { label: "All", value: "All" },
                { label: "Active", value: "Active" },
                { label: "Inactive", value: "Inactive" },
              ]}
              onChange={(val) => setSelectedTab(val)}
              active={selectedTab}
              classname="active-inactive-tab"
            />
          )}
          {/* <RangePickerWithPresets
            fetchData={fetchData}
            fetchData2={fetchData2}
            fetchData3={fetchData3}
          /> */}
          <RangePickerWithPresets
            value={[
              query?.date_from ? dayjs(query.date_from) : null,
              query?.date_to ? dayjs(query.date_to) : null,
            ]}
            onDateChange={(start, end, key) => {
              dispatch(
                setQuery({
                  ...query,
                  date_from: start?.format("YYYY-MM-DD"),
                  date_to: end?.format("YYYY-MM-DD"),
                }),
              );

              fetchData && dispatch(fetchData());
              if (typeof fetchData2 === "function") dispatch(fetchData2());
              if (typeof fetchData3 === "function") dispatch(fetchData3());
            }}
          />

          <FilterDropdown
            secondaryItems={secondaryItems}
            setPrimaryItems={setPrimaryItems}
            setSecondaryItems={setSecondaryItems}
            primaryItems={primaryItems}
            fetchData={fetchData}
            fetchData2={fetchData2}
            fetchData3={fetchData3}
          />
        </div>
      </div>
      <AppliedFilterChips
        leading={
            <div ref={selectRef}>
              <Select
                open={dropdownOpen}
                onDropdownVisibleChange={(open) => {
                  setDropdownOpen(true);
                  setLatestItems([]);
                }}
                dropdownRender={dropdownRender}
                popupClassName="portfolio-dropdown-popup"
                style={{ width: 300 }}
                placeholder="Portfolio"
              />
            </div>
        }
        onRemove={handleRemoveTag}
      />
    </>
  );
};
export default ActionHeader;
